/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/quotes */
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CategoryService } from "../category.service";

@Component({
  selector: "app-add-edit-category",
  templateUrl: "./add-edit-category.component.html",
  styleUrls: ["./add-edit-category.component.scss"],
})
export class AddEditCategoryComponent implements OnInit {
  catNameEng: string = "";
  catNameMar: string = "";

  catId = "";
  flag = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private categoryService: CategoryService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddEditCategoryComponent>
  ) {}

  ngOnInit() {
    console.log(this.data);
    if (this.data[0] == "Edit") {
      this.catId = this.data[1]["pkCatid"];
      this.flag = "E";
      this.catNameEng = this.data[1]["catNameEng"];
      this.catNameMar = this.data[1]["catNameMar"];
    } else {
      this.catId = "";
      this.flag = "N";
    }
  }

  async saveCategory() {
    await this.categoryService
      .saveCategoryV1(this.catId, this.catNameEng, this.catNameMar, this.flag)
      .subscribe((response: any) => {
        console.log(response);
        if (!response.error) {
          if (response.toLowerCase() == "success") {
            this.successToast();
          } else {
            this.warningToast(response);
          }
        } else {
          this.errorToast();
        }
      });
  }

  async successToast() {
    await this._snackBar.open("Category details saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
    this.dialogRef.close("success");
  }

  async warningToast(response) {
    await this._snackBar.open(response, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
